import { Divider, makeStyles, Switch } from "@fluentui/react-components";
import React, { useEffect, useState } from "react";
import ErrorMessage from "../../../components-v2/common/error/ErrorMessage";
import RollingFilter from "../../../components-v2/filters/global-filter/filter-options/RollingFilter";
import { IRollingTime } from "../../../models/common/DateTimeModels";
import { validateRollingTime } from "../../../utils/common/DateHelperFunctions";

interface IFligthKPIRollingInputProps {
  rowIndex: number;
  isRollingTimeActive: boolean;
  toggleActiveRollingTime: () => void;
  rollingTime: IRollingTime;
  updateRollingTime: (
    rowIndex: number,
    rollingTime: IRollingTime,
    isError: boolean
  ) => void;
}

const FligthKPIRollingInput: React.FC<IFligthKPIRollingInputProps> = ({
  rowIndex,
  isRollingTimeActive,
  toggleActiveRollingTime,
  rollingTime,
  updateRollingTime,
}: any) => {
  const classes = useStyles();

  const [fromRollingHours, setFromRollingHours] = useState<number>(
    rollingTime.fromHour
  );
  const [fromRollingMinute, setFromRollingMinute] = useState<number>(
    rollingTime.fromMinute
  );
  const [toRollingHours, setToRollingHours] = useState<number>(
    rollingTime.toHour
  );
  const [toRollingMinute, setToRollingMinute] = useState<number>(
    rollingTime.toMinute
  );

  useEffect(() => {
    setFromRollingHours(rollingTime.fromHour);
    setFromRollingMinute(rollingTime.fromMinute);
    setToRollingHours(rollingTime.toHour);
    setToRollingMinute(rollingTime.toMinute);
  }, [rollingTime]);

  const rollingTimeProps = {
    fromRollingtime: {
      hour: fromRollingHours,
      minute: fromRollingMinute,
      setHour: setFromRollingHours,
      setMinute: setFromRollingMinute,
    },
    toRollingtime: {
      hour: toRollingHours,
      minute: toRollingMinute,
      setHour: setToRollingHours,
      setMinute: setToRollingMinute,
    },
  };

  const errorMsg = validateRollingTime(
    fromRollingHours,
    fromRollingMinute,
    toRollingHours,
    toRollingMinute
  );

  useEffect(() => {
    const isError = errorMsg.length > 0;
    updateRollingTime(
      rowIndex,
      {
        fromHour: fromRollingHours,
        fromMinute: fromRollingMinute,
        toHour: toRollingHours,
        toMinute: toRollingMinute,
      },
      isError
    );
  }, [fromRollingHours, fromRollingMinute, toRollingHours, toRollingMinute]);

  return (
    <section>
      <div className="amd-container-vcenter">
        <Switch
          checked={isRollingTimeActive}
          onChange={toggleActiveRollingTime}
          className={classes.toggleContainer}
        />
        <Divider vertical appearance="strong" className={classes.divider} />
        {isRollingTimeActive ? (
          <RollingFilter
            fromRollingtime={rollingTimeProps.fromRollingtime}
            toRollingtime={rollingTimeProps.toRollingtime}
            redirectionText={false}
            type="kpiConfig"
          />
        ) : (
          <div>Please refer Global Rolling time filter</div>
        )}
      </div>
      {errorMsg.length > 0 && (
        <ErrorMessage errorMsg={errorMsg} className={classes.errorMsg} />
      )}
    </section>
  );
};

export default FligthKPIRollingInput;

const useStyles = makeStyles({
  toggleContainer: {
    padding: "10px",
  },
  divider: {
    height: "70px",
    padding: "0 10px",
  },
  errorMsg: {
    display: "flex",
    alignItems: "center",
  },
});
